import { Dialog, DialogContent, DialogHeader, DialogTitle } from "components/app/dialog/dialog";

import { ArrowLeft, Loader, LoaderCircle, X } from "lucide-react";
import ImageUrlProfileStory from "components/app/image-url/ImageUrlProfileStory";
import SearchBar from "components/app/search-bar/SearchBar";
import { Virtuoso } from "react-virtuoso";
import useNewFeedDialogShareStore from "store/dialog/useNewFeedDialogShare";
import { useEffect, useState } from "react";
import { profileVerified } from "assets";
import { Skeleton } from "components/ui/skeleton";

interface DialogProps {
  isDailogSearchFriendsSend: boolean;
  setIsDailogSearchFriendsSend: (value: boolean) => void;
  submitSendMessage: any;
  loadingButtonIndex: any;
  clickedButtons: any;
}
export default function DailogSearchFriendsSend({ isDailogSearchFriendsSend, setIsDailogSearchFriendsSend, submitSendMessage, loadingButtonIndex, clickedButtons }: DialogProps) {
  const { friends, friendAppRecord, fetchFriends } = useNewFeedDialogShareStore();

  const [searchTextInput, setSearchTextInput] = useState<string>("");

  const loadMoreFriends = () => {
    if (friendAppRecord.canLoadMore() === false || friends.length === 0) {
      return;
    }
    setTimeout(async () => {
      await fetchFriends(false, "");
    }, 1000);
  };

  useEffect(() => {
    if (isDailogSearchFriendsSend) {
      fetchFriends(true, searchTextInput);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTextInput]);

  return (
    <>
      <Dialog open={isDailogSearchFriendsSend}>
        <DialogContent isShowBtnXClose={false} className="max-w-full lg:max-w-[600px]  h-[calc(100vh-80px)] py-2 px-0 flex flex-col p-4 overflow-auto">
          <DialogHeader className="">
            <DialogTitle className=" text-start">
              <div
                onClick={() => {
                  setIsDailogSearchFriendsSend(false);
                }}
                className="flex items-center justify-center cursor-pointer rounded-full hover:bg-accent hover:text-accent-foreground w-[36px] h-[36px]"
              >
                <ArrowLeft />
              </div>
            </DialogTitle>

            <div
              className="absolute flex items-center justify-center right-3 top-1 z-40 cursor-pointer rounded-full hover:bg-accent hover:text-accent-foreground w-[36px] h-[36px] p-2"
              onClick={() => {
                setIsDailogSearchFriendsSend(false);
              }}
            >
              <X />
            </div>
          </DialogHeader>

          <div className="flex flex-1 h-full flex-col space-y-2 ">
            <div className="pe-2 ">
              <SearchBar
                className="mb-2"
                onValueChange={(value) => {
                  setSearchTextInput(value);
                }}
              />
            </div>
            {friendAppRecord.isLoading() ? (
              <div>
                {Array.from({ length: 11 }).map((_, index) => (
                  <div key={index} className="flex justify-between items-center m-2 ">
                    <div className="flex items-center space-x-4">
                      <Skeleton className="h-12 w-12 rounded-full" />
                      <div className="space-y-2">
                        <Skeleton className="h-4 w-[150px]" />
                        <Skeleton className="h-2 w-[160px]" />
                      </div>
                    </div>
                    <Skeleton className="h-7 w-[90px] rounded-md" />
                  </div>
                ))}
              </div>
            ) : (
              <div className="w-full h-full min-h-[300px] space-y-2 mt-4 overflow-x-hidden ">
                <Virtuoso
                  height={"100%"}
                  data={friends}
                  endReached={loadMoreFriends}
                  context={{ friendAppRecord }}
                  overscan={2}
                  itemContent={(index, contact) => (
                    <div className="flex justify-between items-center">
                      <div className="flex flex-row space-x-2 w-full items-center">
                        <ImageUrlProfileStory user={contact} className="w-14 h-14 shrink-0" isLinkProfile={true} />

                        <div className="flex w-full max-w-full flex-row justify-between items-center">
                          <div className="flex flex-col max-w-full w-full">
                            <div className="flex items-center space-x-2 max-w-full">
                              <p className="text-sm font-medium line-clamp-2 overflow-hidden">{contact.name}</p>

                              {contact.is_verified === "Yes" && <img src={profileVerified} alt="" className="w-[15px] h-[15px]" />}
                            </div>

                            <div className="flex items-center space-x-2 max-w-full">
                              <p className="text-xs text-muted-foreground line-clamp-2 overflow-hidden">
                                {`${contact.no_of_follower ? `${contact.no_of_follower} Followers` : ""}
                                    ${contact.no_of_like ? `• ${contact.no_of_like} Likes` : ""}
                                `}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>

                      <button
                        onClick={() => submitSendMessage(contact.id)}
                        className={`px-5 py-1 text-white rounded-md  flex items-center justify-center w-[100px] text-sm font-semibold
                                              ${
                                                loadingButtonIndex === contact.id
                                                  ? "bg-red-500"
                                                  : clickedButtons.includes(contact.id)
                                                  ? "bg-gray-500 cursor-not-allowed"
                                                  : "bg-red-500"
                                              }
                                            `}
                        disabled={loadingButtonIndex === contact.id || clickedButtons.includes(contact.id)}
                      >
                        {loadingButtonIndex === contact.id ? <Loader className="animate-spin size-5" /> : "Send"}
                      </button>
                    </div>
                  )}
                  components={{
                    Footer: () =>
                      friendAppRecord.isLoadingMore() ? (
                        <div>
                          {Array.from({ length: 3 }).map((_, index) => (
                            <div key={index} className="flex justify-between items-center m-2 ">
                              <div className="flex items-center space-x-4">
                                <Skeleton className="h-12 w-12 rounded-full" />
                                <div className="space-y-2">
                                  <Skeleton className="h-4 w-[150px]" />
                                  <Skeleton className="h-2 w-[160px]" />
                                </div>
                              </div>
                              <Skeleton className="h-7 w-[90px] rounded-md" />
                            </div>
                          ))}
                        </div>
                      ) : null,
                  }}
                />
              </div>
            )}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
